
<script setup>

  import { ref, computed } from 'vue';

  import { useMouse, useResizeObserver, watchOnce } from '@vueuse/core';

  const props = defineProps( {
  
    x: { type: Boolean, default: true },

    y: { type: Boolean, default: false },

    z: { type: Number, default: 1 }
  
  } );

  const wrapper = ref( null );

  const centerX = ref( 0 );

  const centerY = ref( 0 );

  const ready = ref( false );
  
  const { x: mouseX, y: mouseY } = useMouse();

  const transform = computed( () => `
  
    translate(
      
      ${ props.x && ready.value ? ( centerX.value - mouseX.value ) / props.z: 0 }px,
    
      ${ props.y && ready.value ? ( centerY.value - mouseY.value ) / props.z : 0 }px
      
    )
    
  ` );

  useResizeObserver( wrapper, entries => {

    const { x, y, width, height } = wrapper.value.getBoundingClientRect();

    centerX.value = ( width - x ) / 2;

    centerY.value = ( height - y ) / 2;

  } );

  watchOnce( [ mouseX, mouseY ], () => ready.value = true );

</script>

<template>

  <div ref="wrapper" class="relative overflow-hidden">

    <div class="absolute w-full h-full" :style="{ transform }">

      <slot />

    </div>

  </div>

</template>
